import { FitnessCenter, TrendingUp } from "@mui/icons-material";
import { Box, Grid, Paper, Typography, useTheme } from "@mui/material";
import React from "react";

export default function MissionAndVision() {
    const theme = useTheme()
  return (
    <Grid container sx={{ mb: 8, gap: { xs: 2, md: 0 } }}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            m: 1,
            borderRadius: 4,
            bgcolor: `${theme.palette.info.main}04`,
            border: `1px solid ${theme.palette.info.main}20`,
            height: "100%",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: theme.shadows[4],
              borderColor: `${theme.palette.primary.main}40`,
            },
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: 2,
              bgcolor: `${theme.palette.info.main}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <FitnessCenter
              sx={{ fontSize: 32, color: theme.palette.info.main }}
            />
          </Box>
          <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 2 }}>
            ماموریت ما
          </Typography>
          <Typography
            sx={{
              fontSize: "0.9rem",
              color: "text.secondary",
              lineHeight: 1.8,
            }}
          >
            ایجاد بستری امن و حرفه‌ای برای همه علاقه‌مندان به ورزش، از مبتدی تا
            حرفه‌ای. ما می‌خواهیم ورزش رو به بخش جدایی‌ناپذیر زندگی روزمره همه
            ایرانیان تبدیل کنیم و با ارائه خدمات باکیفیت، سلامت جامعه رو ارتقا
            بدیم.
          </Typography>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            m: 1,
            borderRadius: 4,
            bgcolor: `${theme.palette.secondary.main}04`,
            border: `1px solid ${theme.palette.secondary.main}20`,
            height: "100%",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: theme.shadows[4],
              borderColor: `${theme.palette.secondary.main}40`,
            },
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: 2,
              bgcolor: `${theme.palette.secondary.main}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <TrendingUp
              sx={{ fontSize: 32, color: theme.palette.secondary.main }}
            />
          </Box>
          <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 2 }}>
            چشم‌انداز ما
          </Typography>
          <Typography
            sx={{
              fontSize: "0.9rem",
              color: "text.secondary",
              lineHeight: 1.8,
            }}
          >
            تبدیل شدن به بزرگترین و معتبرترین پلتفرم ورزشی خاورمیانه تا سال
            ۱۴۰۸. هدف ما ارتقای سطح سلامت و آمادگی جسمانی جامعه و ایجاد اشتغال
            پایدار برای هزاران مربی و متخصص ورزشی در سراسر کشور است.
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
